// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.iframe {\r\n  width: 100%;\r\n  height: calc(100vh - 64px);\r\n  border: 0;\r\n  overflow: hidden;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\n}\r\n", ""]);
// Exports
module.exports = exports;
